import ArticleImage from 'common/Layout/Article/ArticleImage'
import Blockquote from 'common/Layout/Article/components/Blockquote'
import DailyMotion from 'common/Layout/Article/components/DailyMotion'
import FaceBook from 'common/Layout/Article/components/FaceBook'
import Instagram from 'common/Layout/Article/components/Instagram'
import TikTok from 'common/Layout/Article/components/TikTok'
import Tweet from 'common/Layout/Article/components/Tweet'
import DateTime from 'Components/DateTime'
import Divider from 'Components/Divider'
import parse from 'html-react-parser'
import moment from 'moment'
import { FC, Fragment } from 'react'
import { PostInterface, PostItemInterface } from '../Posts.types'
import { AuthorWrapper, PostWrapper } from './Post.styled'

interface Props {
  post: PostInterface
}

const Post: FC<Props> = ({ post }) => {
  if (!post) return null

  const authorName = post.data.extra.authorName

  return (
    <>
      <style jsx>{`
        .video_wrapper {
          height: 310px;
        }
        @media (max-width: 820px) {
          .video_wrapper {
            height: 170px;
          }
        }
      `}</style>
      <PostWrapper id={`post-${post?.data?.id}`}>
        {moment
          .unix(
            post.data.scheduleTime > 0
              ? post.data.scheduleTime
              : post.data.created,
          )
          .fromNow()}
        <h2>{post.data.title}</h2>

        {post.postJson.map((postBody: PostItemInterface, i) => {
          if (postBody?.type === 'markup') {
            return <Fragment key={i}>{parse(postBody.data.markup)}</Fragment>
          }
          if (postBody?.type === 'twitter') {
            return <Tweet key={i} url={postBody.data.url} />
          }
          if (postBody?.type === 'facebook') {
            return <FaceBook key={i} url={postBody.data.url} />
          }
          if (postBody?.type === 'tiktok') {
            return <TikTok key={i} url={postBody.data.url} />
          }
          if (postBody?.type === 'video-dm') {
            return (
              <div key={i} className="video_wrapper">
                <DailyMotion data={postBody.data} post={true} />
              </div>
            )
          }
          if (postBody?.type === 'instagram') {
            return (
              <div key={i}>
                <Instagram key={i} url={postBody?.data.url} />
              </div>
            )
          }
          if (postBody?.type === 'blockquote') {
            return <Blockquote data={postBody?.data} key={i} />
          }
          if (postBody?.type === 'image') {
            return <ArticleImage key={i} image={postBody.data} />
          }
        })}
        <Divider direction="horizontal" />
        <AuthorWrapper>
          {authorName && (
            <>
              <p>
                by <span>{authorName}</span>
              </p>
              <Divider direction="verticle" />
            </>
          )}
          <div className="date_wrapper">
            <DateTime
              time={
                new Date(
                  parseInt(
                    post.data.scheduleTime > 0
                      ? post.data.scheduleTime
                      : post.data.created,
                  ) * 1000,
                )
              }
              type="long"
            />
          </div>
        </AuthorWrapper>
      </PostWrapper>
    </>
  )
}

export default Post
